import { MessageAttachment } from "./types";
import React, { useContext } from "react";
import { MessageContext } from "./MessageContext";
import { Box, IconButton, Stack, Text } from "@origin-digital/ods-core";
import { SelectedFileIcon } from "./Icons";
import { IconClose } from "@origin-digital/ods-icons";

interface ISelectedAttachment {
  messageAttachment: MessageAttachment;
  index: string;
}

const SelectedAttachment = ({
  messageAttachment,
  index,
}: ISelectedAttachment) => {
  const { fileUploadType, fileName } = messageAttachment;
  const { setMessageTabState } = useContext(MessageContext);

  const onRemove = () => {
    setMessageTabState((prevMessageTabState) => ({
      ...prevMessageTabState,
      selectedAttachments: [
        ...prevMessageTabState.selectedAttachments.filter(
          (_, i) => i.toString() !== index
        ),
      ],
    }));
  };

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      backgroundColor="grey50"
      borderRadius="small"
      paddingX="medium"
      paddingY="small"
      id={index}
    >
      <SelectedFileIcon />
      {/* Filename */}
      <Box width="full">
        <Stack space="none">
          <Text>{fileName}</Text>
          <Text variant="body-small" tone="neutralLight">
            {fileUploadType}
          </Text>
        </Stack>
      </Box>
      {/* End Filename */}
      {/* Remove file */}
      <Box marginLeft="small">
        <IconButton
          color="grey300"
          noIconPadding
          aria-label="Remove file"
          onClick={onRemove}
        >
          <IconClose size="xsmall" />
        </IconButton>
      </Box>
      {/* End remove file */}
    </Box>
  );
};

export default SelectedAttachment;
